import { fetchFromAPI } from 'utils/api';

export const fetchPigPulseToken = () => fetchFromAPI('/v2/pigpulse/token', { method: 'POST' });
